import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: '/section/index',
    method: 'get',
    params: query
  })
}

export function fetchDetail(id) {
  return request({
    url: '/section/detail',
    method: 'get',
    params: { id }
  })
}

export function create(data) {
  return request({
    url: '/section/create',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/section/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/section/del',
    method: 'post',
    data
  })
}
